import moment from 'moment';
import { Model, Attr, HasOne } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';
import { User, Booking } from './';

@Model()
export default class BookingLog extends ApplicationRecord {
  static jsonapiType = 'booking-logs';

  static scopeFactory() {
    return BookingLog.includes([]);
  }

  @Attr() action: string;
  @Attr() info: string;
  @Attr() timestamp: string;

  @HasOne() user: User;
  @HasOne() booking: Booking;

  get formattedTime() {
    return moment(this.timestamp).format('D/M/YYYY h:mm a');
  }
}
